import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { callApi, formatDate, formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import OneClassroom from '../ones/OneClassroom';
import { MdCheck, MdDelete, MdSms, MdWhatsapp } from "react-icons/md";

export default function SubjectRegistrationForm({ data, callback }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);

	const [title, setTitle] = useState("");
	const [supportDivisions, setSupportDivisions] = useState('no');
	const [grades, setGrades] = useState([]);
	const [divisions, setDivisions] = useState([]);

	const gradeTemplate = {
		label: "",
		start: 0,
		end: 0,
		points: 0,
		description: "",
	};

	const divisionTemplate = {
		label: "",
		start: 0,
		end: 0,
	}

	function addGrade() {
		setGrades(_prev => {
			const _new = [ ..._prev ];

			_new.push(gradeTemplate);

			return _new;
		})
	}

	function handleGradeChange(index, key, value) {
		setGrades(_prev => {
			const _new = [ ..._prev ];

			if(
				key === 'start' ||
				key === 'end' ||
				key === 'points'
			) {

				if(!isNaN(Number(value))) {
					_prev[index][key] = parseInt(value);
				}

			} else {
				_prev[index][key] = value;
			}

			return _new;
		})
	}

	function deleteGrade(index) {
		setGrades(_prev => {
			const _new = [ ..._prev ];

			_new.splice(index, 1);

			return _new;
		})
	}

	function addDivision() {
		setDivisions(_prev => {
			const _new = [ ..._prev ];

			_new.push(divisionTemplate);

			return _new;
		})
	}

	function handleDivisionChange(index, key, value) {
		setDivisions(_prev => {
			const _new = [ ..._prev ];

			if(
				key === 'start' ||
				key === 'end' 
			) {

				if(!isNaN(Number(value))) {
					_prev[index][key] = parseInt(value);
				}

			} else {
				_prev[index][key] = value;
			}

			return _new;
		})
	}

	function deleteDivision(index) {
		setDivisions(_prev => {
			const _new = [ ..._prev ];

			_new.splice(index, 1);

			return _new;
		})
	}


	async function init() {
		//run initializations here
		setReady(false);
		//..
		setReady(true);
	}

	function resetForm() {
		setTitle("");
		setGrades([]);
		setDivisions([]);
		setSupportDivisions("no");
	}

	async function create() {
		if(title.trim().length > 0) {
			if(grades.length > 0) {
				if(
					(divisions.length > 0 && supportDivisions === 'yes') ||
					supportDivisions === 'no'
				) {
					setLoading(true);
					await callApi(
						"create-grading-system",
						{
							title,
							grades: JSON.stringify(grades),
							divisions: JSON.stringify(divisions),
							supportDivisions,
							schoolUuid: appContext.currentSchoolUuid,
						}
					).then((response) => {
						if(response.status === 1) {
							appContext.tellMessage("Success");
							appContext.getAllGradingSystems();
							resetForm();
						} else {
							appContext.tellError(response.msg)
						}
					})
					setLoading(false);
				} else {
					appContext.tellError("Invalid divisions");
				}
			} else {
				appContext.tellError("Invalid grades");
			}
		} else {
			appContext.tellError("Invalid title");
		}
	}

	async function edit() {
		if(title.trim().length > 0) {
			if(grades.length > 0) {
				if(
					(divisions.length > 0 && supportDivisions === 'yes') ||
					supportDivisions === 'no'
				) {
					setLoading(true);
					await callApi(
						"edit-grading-system",
						{
							uuid: data.uuid,
							title,
							grades: JSON.stringify(grades),
							divisions: JSON.stringify(divisions),
							supportDivisions,
						}
					).then((response) => {
						if(response.status === 1) {
							appContext.tellMessage("Success");
							appContext.getAllGradingSystems();
							
							if(callback) {
								callback();
							}

						} else {
							appContext.tellError(response.msg)
						}
					})
					setLoading(false);
				} else {
					appContext.tellError("Invalid divisions");
				}
			} else {
				appContext.tellError("Invalid grades");
			}
		} else {
			appContext.tellError("Invalid title");
		}
	}


	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		if(data) {
			setTitle(data.title);
			setSupportDivisions(data.supportDivisions);
			setGrades(JSON.parse(data.grades));
			setDivisions(JSON.parse(data.divisions));
		}
	}, [ data ])

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ loading ])

	if (ready) {
		return (
		
			<div className="row">
				<div className="col-md-12 mt-2 mb-2">
					<label className="form-label">Title</label>
					<input
						className="form-control"
						value={title}
						onChange={e => setTitle(e.target.value)}
					/>
				</div>

				<div className="col-md-12 mt-2 mb-2">
					<label className="form-label">Support Divisions?</label>
					<select
						className="form-control"
						value={supportDivisions}
						onChange={e => setSupportDivisions(e.target.value)}
					>
						<option value="yes" >Yes</option>
						<option value="no" >No</option>
					</select>
				</div>

				<div className="col-md-12 mt-2 mb-2">
					<label className="form-label">Grades</label>
					
					<div
						style={{
							width: "100%",
							padding: "10px",
							border: "1px solid black",
						}}
					>

						
						{
							grades.map((item, i) => {
								return (
									<div className="row" key={i}>
										<div className="col-6 col-md-4 mt-2 mb-2">
											<label className="form-label" style={{ fontSize: "12px" }}>Label/Name</label>
											<input
												className="form-control"
												value={item.label}
												onChange={(e) => {
													handleGradeChange(i, 'label', e.target.value)
												}}
											/>
											<div className="form-text">
												eg: A
											</div>
										</div>

										<div className="col-6 col-md-4 mt-2 mb-2">
											<label className="form-label" style={{ fontSize: "12px" }}>Starts</label>
											<input
												className="form-control"
												value={item.start}
												onChange={(e) => {
													handleGradeChange(i, 'start', e.target.value)
												}}
												type="number"
											/>
											<div className="form-text">
												eg: 100
											</div>
										</div>

										<div className="col-6 col-md-4 mt-2 mb-2">
											<label className="form-label" style={{ fontSize: "12px" }}>Ends</label>
											<input
												className="form-control"
												value={item.end}
												onChange={(e) => {
													handleGradeChange(i, 'end', e.target.value)
												}}
												type="number"
											/>
											<div className="form-text">
												eg: 81
											</div>
										</div>

										<div className="col-6 col-md-4 mt-2 mb-2">
											<label className="form-label" style={{ fontSize: "12px" }}>Points (Weight)</label>
											<input
												className="form-control"
												value={item.points}
												onChange={(e) => {
													handleGradeChange(i, 'points', e.target.value)
												}}
												type="number"
											/>
											<div className="form-text">
												eg: 1
											</div>
										</div>

										<div className="col-12 col-md-8 mt-2 mb-2">
											<label className="form-label" style={{ fontSize: "12px" }}>Description</label>
											<input
												className="form-control"
												value={item.description}
												onChange={(e) => {
													handleGradeChange(i, 'description', e.target.value)
												}}
											/>
											<div className="form-text">
												eg: Excellent
											</div>
										</div>

										<div className="col-12 mt-2 mb-2 text-end">
											<MdDelete
												size={24}
												onClick={() => deleteGrade(i)}
												className="text-danger"
												style={{
													cursor: "pointer"
												}}
											/>
											<hr/>
										</div>

									</div>
								)
							})
						}
						

						<div className="mt-2">
							<button
								className="btn btn-sm btn-outline-dark"
								onClick={addGrade}
							>
								Add Grade
							</button>
						</div>

					</div>
				</div>

				{
					(supportDivisions === 'yes') ?
					<div className="col-md-12 mt-2 mb-2">
						<label className="form-label">Divisions</label>
						
						<div
							style={{
								width: "100%",
								padding: "10px",
								border: "1px solid black",
							}}
						>

							
							{
								divisions.map((item, i) => {
									return (
										<div className="row" key={i}>
											<div className="col-6 col-md-4 mt-2 mb-2">
												<label className="form-label" style={{ fontSize: "12px" }}>Label/Name</label>
												<input
													className="form-control"
													value={item.label}
													onChange={(e) => {
														handleDivisionChange(i, 'label', e.target.value)
													}}
												/>
												<div className="form-text">
													eg: Division 1
												</div>
											</div>

											<div className="col-6 col-md-4 mt-2 mb-2">
												<label className="form-label" style={{ fontSize: "12px" }}>Starts</label>
												<input
													className="form-control"
													value={item.start}
													onChange={(e) => {
														handleDivisionChange(i, 'start', e.target.value)
													}}
													type="number"
												/>
												<div className="form-text">
													eg: 7
												</div>
											</div>

											<div className="col-6 col-md-4 mt-2 mb-2">
												<label className="form-label" style={{ fontSize: "12px" }}>Ends</label>
												<input
													className="form-control"
													value={item.end}
													onChange={(e) => {
														handleDivisionChange(i, 'end', e.target.value)
													}}
													type="number"
												/>
												<div className="form-text">
													eg: 9
												</div>
											</div>

											<div className="col-12 mt-2 mb-2 text-end">
												<MdDelete
													size={24}
													onClick={() => deleteDivision(i)}
													className="text-danger"
													style={{
														cursor: "pointer"
													}}
												/>

												<hr/>
											</div>

											
										</div>
									)
								})
							}
							

							<div className="mt-2">
								<button
									className="btn btn-sm btn-outline-dark"
									onClick={addDivision}
								>
									Add Division
								</button>
							</div>

						</div>
					</div>
					:""
				}

				<div className="col-md-12 mt-2 mb-2 text-end">
					<button
						className="btn btn-secondary"
						onClick={() => {
							if(data) {
								appContext.activateDialog({
									message: `Edit this grading system?`,
									onConfirm: edit,
								})
							} else {
								appContext.activateDialog({
									message: `Create new grading system, "${title}"?`,
									onConfirm: create,
								})
							}
						}}
					>
						<MdCheck/> Submit
					</button>
				</div>
			</div>
								
		)
	} else {
		return (
			<div
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}


}